module.exports = __webpack_public_path__ + "static/media/gb-eng.99785a1e.svg";